import type { CSSProperties } from 'react';
import { cn } from '@savvy-kit/lib/utils';

import { dividerColor } from '@savvy/deprecated-shared/theme';

type GradientProgressBarProps = {
  readonly value?: number;
  readonly fixed?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
};

function GradientProgressBar({ value = 0, fixed, className, style }: GradientProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('relative h-3 overflow-hidden', fixed && 'fixed top-0 z-10', className)}
      style={{ border: `1px solid ${dividerColor}`, borderRadius: 0, background: '#FAFBFB', ...style }}
    >
      {/* Mirrors MUI's determinate bar: a full-width element translated left by the
          remaining percentage, so the gradient stop and the translate stay in step. */}
      <div
        className="absolute inset-0 transition-transform duration-200 ease-linear"
        style={{
          transform: `translateX(-${100 - clamped}%)`,
          background: `linear-gradient(90deg, #F4EEE8 ${100 - clamped}%, #175242 100%)`,
        }}
      />
    </div>
  );
}

export default GradientProgressBar;
